// Typed contract for magic-link/sign-in error payloads passed via navigation state

export interface MagicLinkError {
  message: string;
  code?: string;
  description?: string;
}

export function isMagicLinkError(value: unknown): value is MagicLinkError {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as Record<string, unknown>;
  if (typeof v.message !== 'string') return false;
  if (v.code !== undefined && typeof v.code !== 'string') return false;
  if (v.description !== undefined && typeof v.description !== 'string') return false;
  return true;
}


